<template>
  <div>
    <playMusic :bar="play"></playMusic>
    <div class="music-sift">
      <div class="sift-title">精选歌单</div>
      <div class="sift-box">
        <div class="sift-box-left">
          <div class="sift-box-left-img">
            <img src="@/assets/imgs/music-left-1.png" alt="" />
          </div>
          <div class="sift-box-left-img">
            <img src="@/assets/imgs/music-left-2.png" alt="" />
          </div>
        </div>
        <div class="sift-box-right">
          <div
            class="sift-box-right-item"
            :class="highlightImg == index ? 'activeImg' : ''"
            v-for="(item, index) in imgList"
            :key="index"
            @click="playClick(item.id)"
            @mouseover="mouseOverImg(index)"
            @mouseleave="mouseLeave"
          >
            <img :src="item.src" alt="" />
            <div class="sift-box-right-item-bgc"></div>
            <div class="sift-box-right-item-text">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="music-list">
      <div class="list-box1">
        <div class="box-title">经典</div>
        <div
          class="box-item"
          v-for="(item2, index2) in list1"
          :key="index2"
          @mouseover="mouseOver(index2)"
          @mouseleave="mouseLeave"
          :class="highlight == index2 ? 'active' : ''"
          @click="playClick(item2.id)"
        >
          <div class="box-item-song">{{ item2.title }}</div>
          <div class="box-item-time">{{ item2.time }}</div>
        </div>
        <div class="box-more" @click="more">更多...</div>
      </div>
      <div class="list-box2">
        <div class="list-box">
          <div class="box-title">抒情</div>
          <div
            class="box-item"
            v-for="(item3, index3) in list2"
            :key="index3"
            @click="playClick(item3.id)" 
             @mouseover="mouseOverRight(index3)"
            @mouseleave="mouseLeave"
            :class="mouseRight == index3 ? 'active' : ''"
          >
            <div class="box-item-song">{{ item3.title }}</div>
            <div class="box-item-time">{{ item3.time }}</div>
          </div>
          <div class="box-more" @click="more">更多...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "music",
  data() {
    return {
      imgList: [
        {
          id: 0,
          src: require("@/assets/imgs/music-right1.png"),
          title: "送春",
        },
        {
          id: 1,
          src: require("@/assets/imgs/music-right2.png"),
          title: "萤火",
        },
        {
          id: 2,
          src: require("@/assets/imgs/music-right3.png"),
          title: "雨晴",
        },
        {
          id: 3,
          src: require("@/assets/imgs/music-right4.png"),
          title: "燕歌行",
        },
        {
          id: 4,
          src: require("@/assets/imgs/music-right5.png"),
          title: "跋涉者",
        },
        {
          id: 5,
          src: require("@/assets/imgs/music-right6.png"),
          title: "成就梦想",
        },
      ],
      list1: [
        { id: 0, title: "送春", time: "02:46" },
        { id: 1, title: "萤火", time: "02:25" },
        { id: 2, title: "雨晴", time: "02:22" },
        { id: 3, title: "燕歌行", time: "02:30" },
        { id: 4, title: "跋涉者", time: "04:19" },
        { id: 5, title: "成就梦想", time: "03:21" },
        { id: 6, title: "幸福就在眼前", time: "03:35" },
        { id: 7, title: "心里面的思念", time: "03:44" },
        { id: 8, title: "走过千山万水", time: "03:20" },
        { id: 9, title: "真的不后悔", time: "03:25" },
      ],
      list2: [
        { id: 6, title: "幸福就在眼前", time: "03:35" },
        { id: 4, title: "跋涉者", time: "04:19" },
        { id: 9, title: "真的不后悔", time: "03:25" },
        { id: 0, title: "送春", time: "02:46" },
        { id: 7, title: "心里面的思念", time: "03:44" },
        { id: 1, title: "萤火", time: "02:25" },
        { id: 8, title: "走过千山万水", time: "03:20" },
        { id: 3, title: "燕歌行", time: "02:30" },
        { id: 5, title: "成就梦想", time: "03:21" },
        { id: 2, title: "雨晴", time: "02:22" },
      ],
      highlight: -1,
      play: 0,
      highlightImg: -1,
      mouseRight: -1,
    };
  },
  methods: {
    more() {
      this.$router.push("/index/list");
      window.scrollTo(0, 0);
    },
    mouseOver(index) {
      this.highlight = index;
    },
    mouseOverImg(index) {
      this.highlightImg = index;
    },
    mouseOverRight(index) {
      this.mouseRight = index
    },
    mouseLeave() {
      this.highlight = -1;
      this.highlightImg = -1;
      this.mouseRight = -1
    },
    playClick(id) {
      this.play = id;
    },
  },
};
</script>
<style scoped>
.activeImg {
  box-shadow: 0px 0px 15px #000;
}
.music-sift {
  width: 100%;
  height: 100%;
  padding: 20px 360px;
}
.sift-title {
  width: 100%;
  font-size: 24px;
  line-height: 59px;
  border-bottom: 2px #baa364 solid;
  margin-bottom: 30px;
}
.sift-box {
  width: 100%;
  height: 360px;
  display: flex;
}
.sift-box-left {
  flex: 1;
  display: flex;
}
.sift-box-left-img {
  margin-right: 5px;
}
img {
  width: 100%;
  height: 100%;
}
.sift-box-right {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.sift-box-right-item {
  width: 32.5%;
  height: 178px;
  margin-bottom: 4px;
  position: relative;
  overflow: hidden;
}
.sift-box-right-item img {
  transition: transform 1s;
}
.sift-box-right-item img:hover {
  transform: scale(1.4, 1.4);
}
.sift-box-right-item-bgc {
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 0;
  background-color: #000;
  opacity: 0.4;
}
.sift-box-right-item-text {
  width: 100%;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  position: absolute;
  bottom: 0;
}
.music-list {
  width: 100%;
  padding: 20px 360px;
  display: flex;
  justify-content: space-between;
}
.list-box1 {
  width: 45%;
}
.list-box2 {
  width: 45%;
}
.box-title {
  font-size: 25px;
  line-height: 59px;
  border-bottom: 2px #baa364 solid;
  margin-bottom: 1px;
}
.box-item {
  width: 100%;
  height: 50px;
  font-size: 20px;
  line-height: 50px;
  text-indent: 1rem;
  display: flex;
  justify-content: space-between;
  border-radius: 40px;
}
.box-item:nth-child(odd) {
  background-color: #f3f3f3;
}
.box-item-time {
  font-size: 16px;
  margin-right: 20px;
}
.active {
  background-color: #baa364 !important
}
.box-more {
  font-size: 24px;
  line-height: 30px;
  text-indent: 1rem;
  margin: 20px 0 40px 0;
  color: #baa364;
}
</style>
